import { useEffect, useState } from "react";
import { cn } from "../ui/cn";
import { HexButton } from "../ui/HexButton";
import { Logo } from "../ui/Logo";
import { LINKS } from "../data/links";
import { NAV_LINKS } from "../data/footer";

export function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={cn(
        "sticky top-0 z-50 h-16 px-8 flex items-center justify-between",
        "border-b border-dashed transition-all duration-200",
        scrolled
          ? "bg-bg/85 backdrop-blur-md border-dash-d"
          : "bg-transparent border-transparent",
      )}
    >
      <a href="#top" className="flex items-center">
        <Logo size={28} />
      </a>
      <div className="flex gap-1 text-sm max-md:hidden">
        {NAV_LINKS.map(({ label, href }) => (
          <a
            key={label}
            href={href}
            className="px-3.5 py-2 text-td-1/80 hover:text-td-1 transition-colors"
          >
            {label}
          </a>
        ))}
      </div>
      <div className="flex items-center gap-3.5">
        <HexButton variant="primary" size="sm" href={LINKS.setup}>
          Book setup call
        </HexButton>
      </div>
    </nav>
  );
}
